class MCFeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      featuredProduct: '[data-featured-product]'  
    }

    this.classes = {
      active: 'active',
      hidden: 'hidden'
    }
    
    this.data = {
      collectionHandle: 'collectionHandle'
    }

    this.featuredProducts = this.querySelectorAll(this.selectors.featuredProduct);
    
  }

  collectionChangeUnsubscriber = undefined;

  connectedCallback() {
    if (!this.featuredProducts.length) return;
    
    this.collectionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.collectionChange, (event) => {
      const collectionHandle = event.data.collectionHandle;
      this.changeProducts(collectionHandle);
    });
  }

  disconnectedCallback() {
    if (this.collectionChangeUnsubscriber) {
      this.collectionChangeUnsubscriber.unsubscribe();
    }
  }

  changeProducts(collectionHandle) {
    this.featuredProducts.forEach(fp => {
      fp.classList.toggle(this.classes.hidden, fp.dataset[this.data.collectionHandle] != collectionHandle);
    });
  }
  
}

customElements.define('mc-featured-products', MCFeaturedProducts);